import { computed } from 'vue'

import { useSetupDrawer } from '@/components/setup/setupDrawerOpen'
import { setupSurface } from '@/components/setup/setupSurfaceCopy'
import { useSetupState } from '@/composables/setupState'

export function useSetupSurface() {
  const { visible, complete, pendingReview, outstandingCount, steps, progress } = useSetupState()
  const { isOpen, open, toggle } = useSetupDrawer()

  const surface = computed(() =>
    setupSurface({
      complete: complete.value,
      pendingReview: pendingReview.value,
      outstandingCount: outstandingCount.value,
      steps: steps.value
    })
  )

  return { visible, progress, surface, isOpen, open, toggle }
}
